import { createAsyncThunk } from '@reduxjs/toolkit';

export const commonActions = {
  clearCache: createAsyncThunk('common/clearCache', async () => {}),
};
